import { Link } from "react-router-dom";
import { useSaleonthetable } from "../hooks/useSaleonthetable";
import { useEffect, useState } from "react";
import { getSaleontheTable } from "../services/saleontheTable.service";
import { getListingUrl } from "../../../utils/url.utils";
import { LazyLoadImage } from "react-lazy-load-image-component";

function SaleoOnTheTable() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getSaleontheTable();
      setBanners(data);
    };
    fetchData();
  }, []);

  const { tableSectionImage } = useSaleonthetable(banners);

  if (!tableSectionImage) return null;

  return (
    <section className="tabletop">
      <div className="hero-container">
        <div className="hero-text-table">
          <h1>SALE ON THE TABLE</h1>
          <p>
            Stylish tabletop finds now discounted for meals & special moments.
          </p>

          {tableSectionImage?.action_url && (
            <Link to={getListingUrl(tableSectionImage.action_url)} target="_blank" className="hero-button-table" style={{ textDecoration: "none" }}>
              ELEVATE YOUR TABLETOP
            </Link>
          )}
        </div>

        <div className="hero-image">
          {tableSectionImage?.media && (
            <LazyLoadImage
              src={tableSectionImage.media}
              alt={tableSectionImage.name || "Kitchen Utensils"}
              effect="blur"
            />
          )}
        </div>
      </div>
    </section>
  );
}

export default SaleoOnTheTable;